const isSignInOrSignUpRoute = (route) => route === 'signIn' || route === 'signUp';

export { isSignInOrSignUpRoute };
